import { useEffect } from "react";
import Icon from "../../../components/Icon";

// WhatsApp-style full-screen image preview. Click the backdrop or press Esc to
// close; the download button uses the signed download_url (Content-Disposition
// attachment on the server).
export default function ImageLightbox({ attachment, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="chat-lightbox" onClick={onClose}>
      <div className="chat-lightbox-bar" onClick={(e) => e.stopPropagation()}>
        <span className="chat-lightbox-name">{attachment.name}</span>
        <div className="chat-lightbox-actions">
          {attachment.download_url && (
            <a className="chat-lightbox-btn" href={attachment.download_url} target="_blank" rel="noreferrer" title="Download">
              <Icon name="download" size={18} />
            </a>
          )}
          <button type="button" className="chat-lightbox-btn" onClick={onClose} title="Close">
            <Icon name="x" size={18} />
          </button>
        </div>
      </div>
      <img
        className="chat-lightbox-img"
        src={attachment.url}
        alt={attachment.name}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
